import { useCallback } from 'react'
import { setLocals } from '../utils/local'
import StaffService from '../api/staff-service'
import { useNavigate } from 'react-router-dom'
import usePermission from './usePermission'
import { showToast } from '../utils/toast'

const useRefreshEstateAccess = () => {
  const navigate = useNavigate()
  const { getDefaultRoute } = usePermission()

  const refresh = useCallback(
    async (navigateOnSuccess = false) => {
      try {
        const permissionRes = await StaffService.getLoggedInStaffPermission()
        const communityId = permissionRes?.communityId

        if (!communityId) return
        const accessData = await StaffService.getStaffEstateAccess(communityId)
        setLocals({
          token: accessData.tokens.access.token,
          refreshToken: accessData.tokens.refresh.token,
          user: accessData.data.staff,
          estate: accessData.data.estate,
          permissions: accessData.data.permissions,
        })

        if (navigateOnSuccess) {
          const route = getDefaultRoute(accessData.data.permissions)
          navigate(route)
        }
      } catch (err: any) {
        if (err?.message === 'Please verify account.') {
          return
        }
        showToast({
          id: 'estate-access-error',
          title: 'Access error',
          description: err.message || 'Could not refresh access',
          status: 'error',
        })
      }
    },
    [navigate, getDefaultRoute]
  )

  return refresh
}

export default useRefreshEstateAccess
